import type React from 'react';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ModalSmall } from 'library/components/common';
import { useAppDispatch } from 'library/hooks/common';
import { showPopup } from 'library/redux/modal';
import { useProgramShare } from './model';
import * as st from './styles.module.scss';

export const ModalShare: React.FC = () => {
  const [currentValue, setCurrentValue] = useState('');
  const dispatch = useAppDispatch();

  const { isShareModalOpen, toggleShareModal, programId } = useProgramShare();

  useEffect(() => {
    const code = window.location.pathname.split('/')[2];
    if (programId) {
      const rootPath = window.location.origin;
      setCurrentValue(() => `${rootPath}/programs/${code}/program/${programId}`);
    }

    return () => setCurrentValue('');
  }, [currentValue, programId]);

  const onClose = () => toggleShareModal(null);

  const onCopy = () => {
    dispatch(showPopup({ type: 'message', text: 'Скопировано в буфер обмена' }));
    setTimeout(() => {
      onClose();
    }, 1000);
  };

  return (
    <ModalSmall
      isOpen={isShareModalOpen}
      close={onClose}
      onRequestClose={onClose}
      title="Поделиться программой"
      needClose
    >
      <div className={st.share}>
        <textarea defaultValue={currentValue} className={st.input_link} autoFocus />
        <section className={st.share__text}>
          <span>Скопируйте и отправьте ссылку удобным для Вас способом.</span>
        </section>
        <section className={st.share__buttons}>
          <CopyToClipboard text={currentValue} onCopy={onCopy}>
            <button className={st.share__button}>Копировать ссылку</button>
          </CopyToClipboard>
        </section>
      </div>
    </ModalSmall>
  );
};
